module.exports = __webpack_public_path__ + "static/media/basket.00df6fab.svg";